import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import moment from 'moment';
import MeetingConfrim from "./MeetingConfrim";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { SearchSlotList } from "../../services/Api/Module/Slot";
import { Dropdown } from 'primereact/dropdown';
import { CreateBooking } from "../../services/Api/Module/Meeting";
import MeetingConfrimCreate from "./MeetingConfrimCreate";

function AddMeeting({
    open = false,
    vId = 0,
    vType = "DOCTOR",
    onClose = () => console.log("onClose"),
    onRefund = () => console.log("onRefund"),
    onNoRefund = () => console.log("onNoRefund"),
}) {
    const [viewData, setViewData] = useState({});
    const [openConfrim, setOpenConfrim] = useState(false);
    const formattedDate = vId?.start ? moment(vId.start).format('dddd, D MMM') : '';
    const startTime = vId?.start ? moment(vId.start).format('HH:mm') : '';
    const endTime = vId?.end ? moment(vId.end).format('HH:mm') : '';
    const [phoneNumber, setPhoneNumber] = useState('');
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [allSlots, setAllSlots] = useState([]);
    const [slot, setSlot] = useState(null);
    const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorLastName, setErrorLastName] = useState(false);
    const [errorSlot, setErrorSlot] = useState(false);
    const [note, setNote] = useState('');
    const [openQuotaLimitPopup, setOpenQuotaLimitPopup] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const isSubmittingRef = useRef(false);

    const handleOnClose = () => {
        setIsSubmitting(false)
        isSubmittingRef.current = false
        setName(null)
        setLastName(null)
        setPhoneNumber(null)
        setSlot(null)
        setNote('')
        setErrorName(false)
        setErrorLastName(null)
        setErrorSlot(false)
        setErrorPhoneNumber(false)
        onClose()
    }
    const handleOnCloseConfirm = () => {
        setOpenConfrim(false)
        onClose()
    }
    const handleQuotaLimitClose = () => {
        setOpenQuotaLimitPopup(false);
    }

    const handleOnConfirm = async () => {
        if (isSubmittingRef.current) {
            return;
        }
        if (!name) {
            setErrorName(true)
        }
        if (!lastName) {
            setErrorLastName(true)
        }
        if (!phoneNumber || phoneNumber.length !== 10) {
            setErrorPhoneNumber(true)
        }
        if (!slot) {
            setErrorSlot(true)
        }
        if (name && lastName && phoneNumber.length === 10 && slot) {
            const payload = {
                "firstName": name,
                "lastName": lastName,
                "contactNumber": phoneNumber,
                "slot": slot,
                "consultSelected": vId.consultSelected,
                "note": note || ''
            }
            console.log('CreateBooking payload:', payload);
            try {
                isSubmittingRef.current = true;
                setIsSubmitting(true);
                const response = await CreateBooking({ data: payload });
                const resData = response.data
                const resultCode = String(resData?.resultCode);
                if(resultCode === "20000") {
                    setOpenConfrim(true)
                } else if (resultCode === "40501") {
                    setOpenQuotaLimitPopup(true);
                }
            } catch (error) {
                console.log(error)
                const resultCode = String(error?.response?.data?.resultCode);
                if (resultCode === "40501") {
                    setOpenQuotaLimitPopup(true);
                }
            } finally {
                isSubmittingRef.current = false;
                setIsSubmitting(false);
            }
        }
    }



    const getSlotList = async () => {
        try {
            console.log(vId)
            const smDoctor = vId.doctorDetail ? vId.doctorDetail.id : 0;
            const consultSelected = vId.consultSelected
            const consultDate = moment(vId.start).format('yyyy-MM-DD')
            const response = await SearchSlotList({ params: { smDoctor, consultSelected, consultDate } });
            const resData = response.data
            var result = resData.resultData
            var slotAll = []
            result.forEach(element => {
                element.timetable = element.consultTimeStart + '- ' + element.consultTimeEnd
                if (element.slotStatus == 1) {
                    slotAll.push(element)
                }

            });
            setAllSlots(slotAll)
            return resData;
        } catch (error) {
            console.error('Error adding user:', error);
            // return error;
            throw error;
        }
    }


    useEffect(() => {
        setName(null)
        setLastName(null)
        setPhoneNumber(null)
        setSlot(null)
        setErrorName(false)
        setErrorLastName(null)
        setErrorSlot(false)
        setErrorPhoneNumber(false)
        setIsSubmitting(false)
        isSubmittingRef.current = false
        if (open) {
            const payload = {
                id: vId,
                type: vType,
            };
            getSlotList();
            setNote('');
            // setViewData()
        } else {
            setViewData({}); // clear เมื่อปิด
        }
    }, [open]);



    return (
        <Dialog
            visible={open}
            style={{ width: "500px" }}
            onHide={() => onClose()}
            draggable={false}
            resizable={false}
            closable={false}
        >
            <div
                className="bModal bCard"
                id="confirmModal"
                style={{ display: "block" }}
            >
                <div className="closeBtn btnCloseModal" onClick={handleOnClose}></div>
                <div className="bInner-calendarDetail">
                    <div className="bTitle">
                        <div className="bHead">
                            <h2>{vId?.consultSelected == "nurse" ? "คุยกับพยาบาล" : "คุยกับหมอ"}</h2>
                            <div>{vId?.consultSelected == "doctor" ? (`${vId?.doctorDetail?.firstName} ${vId?.doctorDetail?.lastName}`) : ''}</div>
                            <p>{formattedDate}</p>
                        </div>

                        <div className="tAddMeeting">
                            <div className="tName">
                                <label htmlFor="username">ชื่อคนไข้</label>
                            </div>
                            <InputText invalid={errorName} value={name}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        setErrorName(false)
                                    }
                                    setName(e.target.value)
                                }} aria-describedby="username-help" className="txtAddMeet" />
                            <small className="txe-help">{errorName ? 'กรุณากรอกชื่อคนไข้' : ''}</small>
                            <div className="tName">
                                <label htmlFor="username">นามสกุลคนไข้</label>
                            </div>
                            <InputText invalid={errorLastName} value={lastName}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        setErrorLastName(false)
                                    }
                                    setLastName(e.target.value)
                                }} aria-describedby="username-help" className="txtAddMeet" />
                            <small className="txe-help">{errorLastName ? 'กรุณากรอกนามสกุลคนไข้' : ''}</small>
                            <div className="tName">
                                <label htmlFor="username">เลือกเวลา</label>
                            </div>
                            <Dropdown invalid={errorSlot} value={slot}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        setErrorSlot(false)
                                    }
                                    setSlot(e.value)
                                }} options={allSlots} optionLabel="timetable" className="txtAddMeet" />
                            {errorSlot ? <small className="txe-help">กรุณาเลือกเวลาจอง</small> : <></>}

                            <div className="tName">
                                <label htmlFor="username">เบอร์โทรศัพท์</label>
                            </div>
                            <InputText maxlength="10" minLength="10" invalid={errorPhoneNumber} required={true} value={phoneNumber}
                                onChange={(e) => {
                                    if (e.target.value && e.target.value.length === 10) {
                                        setErrorPhoneNumber(false)
                                    }
                                    setPhoneNumber(e.target.value)
                                }} aria-describedby="username-help" className="txtAddMeet" keyfilter="int" />
                            <small className="txe-help">{errorPhoneNumber ? 'กรุณากรอกเบอร์โทรศัพท์' : ''}</small>

                            <div className="tName">
                                <label htmlFor="note">รายละเอียดเพิ่มเติม</label>
                            </div>
                            <InputTextarea
                                id="note"
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                placeholder="กรอกรายละเอียดเพิ่มเติม (ถ้ามี)"
                                className="txtAddMeet"
                                rows={3}
                                autoResize
                            />

                        </div>
                    </div>
                    <div className="bBtn btnAddModal">
                        <button style={{ marginRight: "15px" }} className="btnCloseAdd" onClick={handleOnClose}>ยกเลิก</button>
                        <button className="btnCloseAdd" onClick={handleOnConfirm} disabled={isSubmitting}>
                            {isSubmitting ? 'กำลังจอง...' : 'ยืนยันการจอง'}
                        </button>

                    </div>
                </div>
            </div>
            <MeetingConfrimCreate
                open={openConfrim}
                onClose={handleOnCloseConfirm}
            />
            <Dialog
                visible={openQuotaLimitPopup}
                style={{ width: "500px" }}
                onHide={handleQuotaLimitClose}
                draggable={false}
                resizable={false}
                closable={false}
            >
                <div className="bModal bCard" style={{ display: "block" }}>
                    <div className="bInner">
                        <div className="bTitle">
                            <span>ไม่สามารถจองนัดหมายได้</span>
                            <p>เนื่องจากคุณแม่ใช้โควต้าของเดือนนี้ครบถ้วนแล้ว</p>
                        </div>
                        <div className="bBtn">
                            <button className="btn btnCloseModal" onClick={handleQuotaLimitClose}>
                                ตกลง
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Dialog>
    );
}

export default AddMeeting;
